import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useEquipmentStore } from "../store/equipment";
import {
  TranslationMessagesContext,
  TranslationsContext,
} from "../util/Translations";
import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonCol,
  IonGrid,
  IonRow,
  IonText,
} from "@ionic/react";
import { maxResults } from "../hooks/useQueryExec";
import Fuse from "fuse.js";
import CardFilter from "./CardFilter";

export default function DownloadedEquipments() {
  const downloadedEquip = useEquipmentStore(
    (state) => state.downloadedInspection
  );

  const { translatedMessages } = useContext(TranslationMessagesContext);
  const [searchText, setSearchText] = useState("");
  const { translations } = useContext(TranslationsContext);

  const [filteredRows, setFilteredRows] = useState(downloadedEquip);

  useEffect(() => {
    setFilteredRows(downloadedEquip);
  }, [downloadedEquip]);

  const hasDownloadedEquip = downloadedEquip.length > 0;

  const fuse = useMemo(
    () =>
      new Fuse(downloadedEquip, {
        keys: ["equipmentId", "id", "name"],
        includeScore: true,
        minMatchCharLength: 2,
        threshold: 0.5,
        // shouldSort: true,
      }),
    [downloadedEquip]
  );

  const handleFilter = useCallback(
    async (queryString: string) => {
      if (queryString) {
        const res = fuse.search(queryString);
        setFilteredRows(res.map((r) => r.item).slice(0, maxResults));
      } else {
        setFilteredRows(downloadedEquip.slice(0, maxResults));
      }
      setSearchText(queryString);
    },
    [downloadedEquip, fuse]
  );

  return (
    <>
      <CardFilter
        hideFilter={downloadedEquip.length <= 0}
        queryRows={[
          {
            Columns: [
              {
                Hidden: false,
                Name: "Name",
                Order: 1,
                Text: "Text",
                Type: "",
                Value: "",
              },
            ],
            HeaderColor: "",
            HeaderName: "",
            HeaderRow: 0,
            HeaderText: "",
            HeaderType: "",
            HeaderValue: "",
          },
        ]}
        resultsFilter={searchText}
        filterMethod={handleFilter}
      />
      {hasDownloadedEquip &&
        filteredRows.map(({ equipmentId, id, name, status }) => {
          const encodedEq = equipmentId ? encodeURIComponent(equipmentId) : "";
          let routerLink = encodedEq
            ? `/Equipment/${encodedEq}/inspection/${id}`
            : undefined;

          return (
            <IonCard key={id} routerLink={routerLink}>
              <IonCardHeader>
                <IonCardTitle>{equipmentId}</IonCardTitle>
              </IonCardHeader>
              <IonCardContent>
                <IonGrid>
                  <IonRow>
                    <IonCol>
                      {translations["lbl_inspection_id"] || "Inspection ID"}
                    </IonCol>
                    <IonCol> {id}</IonCol>
                  </IonRow>
                  <IonRow>
                    <IonCol>{translations["lbl_name"] || "Name"}</IonCol>
                    <IonCol> {name}</IonCol>
                  </IonRow>
                  <IonRow>
                    <IonCol>{translations["lbl_status"] || "Status"}</IonCol>
                    <IonCol>
                      {" "}
                      <IonText
                        color={
                          status === "Completed"
                            ? "success"
                            : status === "Failed"
                            ? "danger"
                            : "warning"
                        }
                      >
                        {" "}
                        {status}
                      </IonText>
                    </IonCol>
                  </IonRow>
                </IonGrid>
              </IonCardContent>
            </IonCard>
          );
        })}

      <IonText
        hidden={hasDownloadedEquip}
        color={"default"}
        style={{ padding: "16px", display: "inline-block" }}
      >
        {translatedMessages["NoResultsFound"]?.MessageText ||
          "No results found."}
      </IonText>
    </>
  );
}
